// // ============================================================
// // src/components/WhyUs.js
// // ✅ Already fully dynamic via HospitalContext — no changes needed
// // ============================================================
// import React from "react";
// import { useHospital } from "../context/HospitalContext";

// const DEFAULT_FEATURES = [
//   {
//     icon: "🏆",
//     title: "Award-Winning Specialists",
//     desc: "Our team of 20+ specialists hold advanced certifications from top dental institutes and international bodies.",
//   },
//   {
//     icon: "🤖",
//     title: "Latest Technology",
//     desc: "3D X-rays, digital impressions, laser dentistry, and same-day crowns using our in-house CEREC system.",
//   },
//   {
//     icon: "😌",
//     title: "Pain-Free Guarantee",
//     desc: "Advanced sedation options and gentle techniques ensure you never feel a thing. Zero-anxiety dentistry.",
//   },
//   {
//     icon: "⏰",
//     title: "Same-Day Appointments",
//     desc: "Emergency dental care available 7 days a week. Walk-ins welcome. No waiting for weeks.",
//   },
// ];

// const DEFAULT_STATS = [
//   { num: "18,000+", label: "Smiles Transformed" },
//   { num: "20+", label: "Specialist Doctors" },
//   { num: "4.9★", label: "Average Patient Rating" },
//   { num: "98%", label: "Would Recommend Us" },
// ];

// export default function WhyUs() {
//   const { hospital } = useHospital();

//   const whyTitle = hospital.whyUsTitle || "Why PearlSmile";
//   const whyTagline = hospital.whyUsTagline || "Care You Can Trust Completely";
//   const whyDesc =
//     hospital.whyUsDesc ||
//     "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.";
//   const features =
//     hospital.whyUsFeatures?.length > 0
//       ? hospital.whyUsFeatures
//       : DEFAULT_FEATURES;
//   const stats =
//     hospital.whyUsStats?.length > 0 ? hospital.whyUsStats : DEFAULT_STATS;

//   const taglineParts = whyTagline.split("Trust");
//   const taglineMain = taglineParts[0] || whyTagline;
//   const taglineEm = taglineParts.length > 1 ? "Trust" + taglineParts[1] : "";

//   return (
//     <section className="why-us" id="about">
//       <div className="why-us-bg" />
//       <div className="why-us-inner">
//         <div>
//           <div className="section-tag">
//             Why {hospital.name ? hospital.name.split(" ")[0] : "PearlSmile"}
//           </div>
//           <h2 className="section-title">
//             {taglineEm ? (
//               <>
//                 {taglineMain}
//                 <br />
//                 <em>{taglineEm}</em>
//               </>
//             ) : (
//               <>{whyTagline}</>
//             )}
//           </h2>
//           <p className="section-desc">{whyDesc}</p>
//           <div className="features-list">
//             {features.map((f, i) => (
//               <div className="feature-item" key={i}>
//                 <div className="feature-icon">{f.icon}</div>
//                 <div>
//                   <h4>{f.title}</h4>
//                   <p>{f.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="why-visual">
//           {stats.map((s, i) => (
//             <div className="why-stat-card" key={i}>
//               <div className="wsc-num">{s.num}</div>
//               <div className="wsc-label">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// // ============================================================
// // src/components/WhyUs.js
// // ✅ Specialty text wired via getSpecialtyText()
// // ============================================================
// import React from "react";
// import { useHospital } from "../context/HospitalContext";
// import { getSpecialtyText } from "../utils/specialtyText";

// const DEFAULT_FEATURES = [
//   {
//     icon: "🏆",
//     title: "Award-Winning Specialists",
//     desc: "Our team of 20+ specialists hold advanced certifications from top dental institutes and international bodies.",
//   },
//   {
//     icon: "🤖",
//     title: "Latest Technology",
//     desc: "3D X-rays, digital impressions, laser dentistry, and same-day crowns using our in-house CEREC system.",
//   },
//   {
//     icon: "😌",
//     title: "Pain-Free Guarantee",
//     desc: "Advanced sedation options and gentle techniques ensure you never feel a thing. Zero-anxiety dentistry.",
//   },
//   {
//     icon: "⏰",
//     title: "Same-Day Appointments",
//     desc: "Emergency dental care available 7 days a week. Walk-ins welcome. No waiting for weeks.",
//   },
// ];

// const DEFAULT_STATS = [
//   { num: "18,000+", label: "Smiles Transformed" },
//   { num: "20+", label: "Specialist Doctors" },
//   { num: "4.9★", label: "Average Patient Rating" },
//   { num: "98%", label: "Would Recommend Us" },
// ];

// export default function WhyUs() {
//   const { hospital } = useHospital();
//   const t = getSpecialtyText(hospital.type);

//   const whyTitle =
//     hospital.whyUsTitle || `Why ${hospital.name?.split(" ")[0] || "Us"}`;
//   const whyTagline = hospital.whyUsTagline || "Care You Can Trust Completely";
//   const whyDesc =
//     hospital.whyUsDesc ||
//     "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.";
//   const features =
//     hospital.whyUsFeatures?.length > 0
//       ? hospital.whyUsFeatures
//       : DEFAULT_FEATURES;
//   const stats =
//     hospital.whyUsStats?.length > 0 ? hospital.whyUsStats : DEFAULT_STATS;

//   const taglineParts = whyTagline.split("Trust");
//   const taglineMain = taglineParts[0] || whyTagline;
//   const taglineEm = taglineParts.length > 1 ? "Trust" + taglineParts[1] : "";

//   return (
//     <section className="why-us" id="about">
//       <div className="why-us-bg" />
//       <div className="why-us-inner">
//         <div>
//           {/* ✅ Specialty-aware tag */}
//           <div className="section-tag">{t.whyTag}</div>
//           <h2 className="section-title">
//             {taglineEm ? (
//               <>
//                 {taglineMain}
//                 <br />
//                 <em>{taglineEm}</em>
//               </>
//             ) : (
//               <>{whyTagline}</>
//             )}
//           </h2>
//           <p className="section-desc">{whyDesc}</p>
//           <div className="features-list">
//             {features.map((f, i) => (
//               <div className="feature-item" key={i}>
//                 <div className="feature-icon">{f.icon}</div>
//                 <div>
//                   <h4>{f.title}</h4>
//                   <p>{f.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="why-visual">
//           {stats.map((s, i) => (
//             <div className="why-stat-card" key={i}>
//               <div className="wsc-num">{s.num}</div>
//               <div className="wsc-label">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

/////////////// hospital seeting isolated ////////
// ============================================================
// src/components/WhyUs.js
// ✅ Specialty text wired via getSpecialtyText()
// ✅ DEFAULT_FEATURES and DEFAULT_STATS by hospital type
// ============================================================
import React from "react";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

// ✅ Dental defaults — detect stale data
const DENTAL_WHY_TITLE = "Why PearlSmile";
const DENTAL_WHY_TAGLINE = "Care You Can Trust Completely";
const DENTAL_WHY_DESC =
  "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.";

const DEFAULT_WHY_US_BY_TYPE = {
  dental: {
    title: "Why PearlSmile",
    tagline: "Care You Can Trust Completely",
    desc: "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.",
  },
  ayurved: {
    title: "Why Choose Us",
    tagline: "Healing You Can Trust Completely",
    desc: "We combine ancient Ayurvedic wisdom with modern wellness science, ensuring every therapy restores your body, mind, and spirit.",
  },
  ortho: {
    title: "Why Choose Us",
    tagline: "Mobility You Can Trust Completely",
    desc: "We combine advanced surgical expertise with personalised rehabilitation, ensuring every patient regains strength and lives pain-free.",
  },
  eye: {
    title: "Why Choose Us",
    tagline: "Vision You Can Trust Completely",
    desc: "We combine cutting-edge optical technology with expert surgical care, ensuring every patient sees the world with clarity and confidence.",
  },
  cardiology: {
    title: "Why Choose Us",
    tagline: "Heart Care You Can Trust Completely",
    desc: "We combine world-class cardiac expertise with compassionate care, ensuring every heartbeat is protected with precision and dedication.",
  },
  pediatric: {
    title: "Why Choose Us",
    tagline: "Child Care You Can Trust Completely",
    desc: "We combine expert pediatric medicine with a child-friendly approach, ensuring every child receives gentle, compassionate, and effective healthcare.",
  },
  general: {
    title: "Why Choose Us",
    tagline: "Healthcare You Can Trust Completely",
    desc: "We combine multi-specialty medical expertise with compassionate patient care, ensuring every patient receives the right treatment under one roof.",
  },
};

// ✅ Default features by hospital type
const DEFAULT_FEATURES_BY_TYPE = {
  dental: [
    {
      icon: "🏆",
      title: "Award-Winning Specialists",
      desc: "Our team of 20+ specialists hold advanced certifications from top dental institutes and international bodies.",
    },
    {
      icon: "🤖",
      title: "Latest Technology",
      desc: "3D X-rays, digital impressions, laser dentistry, and same-day crowns using our in-house CEREC system.",
    },
    {
      icon: "😌",
      title: "Pain-Free Guarantee",
      desc: "Advanced sedation options and gentle techniques ensure you never feel a thing. Zero-anxiety dentistry.",
    },
    {
      icon: "⏰",
      title: "Same-Day Appointments",
      desc: "Emergency dental care available 7 days a week. Walk-ins welcome. No waiting for weeks.",
    },
  ],
  ayurved: [
    {
      icon: "🌿",
      title: "100% Natural Treatments",
      desc: "All therapies use authentic Ayurvedic herbs, oils, and techniques — no chemicals, no side effects.",
    },
    {
      icon: "✨",
      title: "Herbal Skin & Beauty Care",
      desc: "Traditional Ayurvedic beauty treatments for glowing skin and natural rejuvenation.",
    },
    {
      icon: "🏅",
      title: "Nationally Recognized Wellness Center",
      desc: "Certified by leading Ayurveda boards with decades of trusted healing practice.",
    },
    {
      icon: "🤲",
      title: "Dosha-Based Personalized Therapy",
      desc: "Every treatment is tailored to your unique body constitution for deep, lasting healing.",
    },
  ],
  ortho: [
    {
      icon: "🔬",
      title: "Minimally Invasive Surgeries",
      desc: "Advanced arthroscopic and keyhole techniques for faster recovery and minimal scarring.",
    },
    {
      icon: "🏃",
      title: "Sports Injury Rehabilitation",
      desc: "Comprehensive rehab programs designed by sports medicine experts to get you back on track.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Surgical Team",
      desc: "Our orthopedic surgeons are recognized nationally for excellence in joint and spine surgery.",
    },
    {
      icon: "💊",
      title: "Advanced Pain Management",
      desc: "Multimodal pain management protocols ensuring comfort before, during, and after surgery.",
    },
  ],
  eye: [
    {
      icon: "👁️",
      title: "Bladeless & Painless Surgeries",
      desc: "Latest LASIK and cataract techniques using femtosecond laser for precision and zero discomfort.",
    },
    {
      icon: "✨",
      title: "Oculoplasty & Cosmetic Eye Care",
      desc: "Expert cosmetic and reconstructive eye procedures for appearance and function.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Eye Care Center",
      desc: "Recognized for excellence in ophthalmology with thousands of successful surgeries annually.",
    },
    {
      icon: "🔬",
      title: "Advanced Laser & Imaging Center",
      desc: "State-of-the-art OCT, fundus photography, and laser systems for precise diagnosis and treatment.",
    },
  ],
  cardiology: [
    {
      icon: "❤️",
      title: "Minimally Invasive Cardiac Procedures",
      desc: "Cutting-edge catheterization and stenting techniques with minimal recovery time.",
    },
    {
      icon: "🛡️",
      title: "Preventive Heart Care Programs",
      desc: "Comprehensive cardiac risk assessment, lifestyle counseling, and early intervention programs.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Cardiac Center",
      desc: "Nationally accredited cardiac care with industry-leading outcomes and patient satisfaction.",
    },
    {
      icon: "🏥",
      title: "Cath Lab & Advanced Cardiac ICU",
      desc: "24/7 fully equipped catheterization lab and cardiac intensive care unit for critical cases.",
    },
  ],
  pediatric: [
    {
      icon: "👶",
      title: "Gentle & Child-Friendly Procedures",
      desc: "Every procedure is designed to minimize discomfort with child-specific anesthesia and care protocols.",
    },
    {
      icon: "📈",
      title: "Child Growth & Nutrition Counseling",
      desc: "Expert guidance on age-appropriate nutrition, developmental milestones, and healthy growth.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Children's Hospital",
      desc: "Trusted by thousands of families for compassionate, expert pediatric care.",
    },
    {
      icon: "🌈",
      title: "Child-Safe & Friendly Environment",
      desc: "Our hospital is designed specifically for children — colorful, safe, and anxiety-free.",
    },
  ],
  general: [
    {
      icon: "🏥",
      title: "Multi-Specialty Departments",
      desc: "All major specialties under one roof — cardiology, orthopedics, gynecology, ENT, and more.",
    },
    {
      icon: "🏅",
      title: "NABH Accredited Hospital",
      desc: "Nationally accredited for quality, safety, and patient-centered care standards.",
    },
    {
      icon: "🚑",
      title: "Advanced ICU & Critical Care",
      desc: "24/7 ICU with ventilators, monitors, and critical care specialists always on standby.",
    },
    {
      icon: "🔬",
      title: "Fully Equipped Multi-Specialty Facility",
      desc: "State-of-the-art diagnostics, OT, and imaging — everything needed for complete healthcare.",
    },
  ],
};

// ✅ Default stats by hospital type
const DEFAULT_STATS_BY_TYPE = {
  dental: [
    { num: "18,000+", label: "Smiles Transformed" },
    { num: "20+", label: "Specialist Doctors" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "98%", label: "Would Recommend Us" },
  ],
  ayurved: [
    { num: "25,000+", label: "Lives Healed Naturally" },
    { num: "50+", label: "Certified Vaidyas & Therapists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "96%", label: "Patients Recommend Us" },
  ],
  ortho: [
    { num: "30,000+", label: "Surgeries Performed" },
    { num: "40+", label: "Orthopedic Specialists" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "97%", label: "Pain-Free After Treatment" },
  ],
  eye: [
    { num: "50,000+", label: "Eyes Treated Successfully" },
    { num: "30+", label: "Expert Ophthalmologists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "99%", label: "LASIK Success Rate" },
  ],
  cardiology: [
    { num: "20,000+", label: "Cardiac Procedures Done" },
    { num: "25+", label: "Senior Cardiologists" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "98%", label: "Patients Recovered Successfully" },
  ],
  pediatric: [
    { num: "35,000+", label: "Children Treated" },
    { num: "45+", label: "Pediatric Specialists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "97%", label: "Parents Recommend Us" },
  ],
  general: [
    { num: "1,00,000+", label: "Patients Treated" },
    { num: "100+", label: "Specialist Doctors" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "98%", label: "Would Recommend Us" },
  ],
};

export default function WhyUs() {
  const { hospital } = useHospital();
  const t = getSpecialtyText(hospital.type);
  const type = (hospital.type || "dental").toLowerCase();

  const whyDefaults =
    DEFAULT_WHY_US_BY_TYPE[type] || DEFAULT_WHY_US_BY_TYPE.dental;

  // ✅ Use type-specific default if empty OR still has dental default (for non-dental hospitals)
  const whyTitle =
    hospital.whyUsTitle &&
    (type === "dental" || hospital.whyUsTitle !== DENTAL_WHY_TITLE)
      ? hospital.whyUsTitle
      : whyDefaults.title;
  const whyTagline =
    hospital.whyUsTagline &&
    (type === "dental" || hospital.whyUsTagline !== DENTAL_WHY_TAGLINE)
      ? hospital.whyUsTagline
      : whyDefaults.tagline;
  const whyDesc =
    hospital.whyUsDesc &&
    (type === "dental" || hospital.whyUsDesc !== DENTAL_WHY_DESC)
      ? hospital.whyUsDesc
      : whyDefaults.desc;

  // ✅ Dental defaults — detect and override for non-dental hospitals
  const dentalFeatureTitles = DEFAULT_FEATURES_BY_TYPE.dental.map(
    (f) => f.title,
  );
  const dentalStatNums = DEFAULT_STATS_BY_TYPE.dental.map((s) => s.num);

  const savedFeatures = hospital.whyUsFeatures || [];
  const featuresAreDentalDefault =
    savedFeatures.length > 0 &&
    dentalFeatureTitles.every((t) => savedFeatures.some((f) => f.title === t));
  const features =
    savedFeatures.length === 0 ||
    (type !== "dental" && featuresAreDentalDefault)
      ? DEFAULT_FEATURES_BY_TYPE[type] || DEFAULT_FEATURES_BY_TYPE.dental
      : savedFeatures;

  const savedStats = hospital.whyUsStats || [];
  const statsAreDentalDefault =
    savedStats.length > 0 &&
    dentalStatNums.every((n) => savedStats.some((s) => s.num === n));
  const stats =
    savedStats.length === 0 || (type !== "dental" && statsAreDentalDefault)
      ? DEFAULT_STATS_BY_TYPE[type] || DEFAULT_STATS_BY_TYPE.dental
      : savedStats;

  const taglineParts = whyTagline.split("Trust");
  const taglineMain = taglineParts[0] || whyTagline;
  const taglineEm = taglineParts.length > 1 ? "Trust" + taglineParts[1] : "";

  return (
    <section className="why-us" id="about">
      <div className="why-us-bg" />
      <div className="why-us-inner">
        <div>
          <div className="section-tag">{t.whyTag}</div>
          <h2 className="section-title">
            {taglineEm ? (
              <>
                {taglineMain}
                <br />
                <em>{taglineEm}</em>
              </>
            ) : (
              <>{whyTagline}</>
            )}
          </h2>
          <p className="section-desc">{whyDesc}</p>
          <div className="features-list">
            {features.map((f, i) => (
              <div className="feature-item" key={i}>
                <div className="feature-icon">{f.icon}</div>
                <div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="why-visual">
          {stats.map((s, i) => (
            <div className="why-stat-card" key={i}>
              <div className="wsc-num">{s.num}</div>
              <div className="wsc-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
